import React from 'react';
import InfoLink from '../components/InfoLink';

const TitleHeader = (props) => {
  let divClasses = 'card-header ';

  if (props.containerClass) {
    divClasses += props.containerClass;
  }

  return(
    <div className={divClasses}>
      <h4>{props.title}</h4>
      {props.required && <span className="text-danger font-weight-bold"> *</span>}
      {props.infoUrl && <InfoLink link={props.infoUrl}/>}
      {props.children}
    </div>
  );
};

export default TitleHeader;


// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/TitleHeader.jsx